import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import InfoBox from '@/components/InfoBox';
import VerifyListItem
  from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/VerifyListItem';
import {usePartnersCapital} from '@/modules/proposalRequest/hooks/usePartnersCapital';
import {showPrice} from '@/utils/utils';

const ProposalCapitalSummary = ({partners, isCNA, proposal, isProcedure, ...rest}) => {
  const {t} = useTranslation('proposalRequest');
  const {socialAmountTotal, monetaryAmountTotal, totalAmount} = usePartnersCapital(partners || []);

  return (
    <div {...rest}>
      <div className="mb-4">
        <VerifyListItem
          labelKey={t(`proposalRequest.form.partners.socialCapital.${isCNA ? 'initialAmountOfWork' : 'monetaryAmountSummary'}`)}
          fullView
          fullSpace>
          {showPrice(totalAmount || proposal?.socialCapital || '0')}
        </VerifyListItem>
        <InfoBox title={'proposalRequest.form.partners.socialCapital.amountSummaryHelp'} translate={'proposalRequest'}/>
      </div>
      <VerifyListItem labelKey={
        t(`proposalRequest.form.partners.socialCapital.${isProcedure ? 'procedureCapitalAmountSummary' : 'capitalAmountSummary'}`)
      } fullView fullSpace>
        {showPrice(monetaryAmountTotal || proposal?.cashSocialCapital || '0')}
      </VerifyListItem>
      <VerifyListItem labelKey={t('proposalRequest.form.partners.socialCapital.goodsAmountSummary')} fullView fullSpace>
        {showPrice(socialAmountTotal || proposal?.goodsTotalCapital || '0')}
      </VerifyListItem>
    </div>
  );
};

ProposalCapitalSummary.propTypes = {
  partners: PropTypes.array,
  proposal: PropTypes.object,
  isCNA: PropTypes.bool,
  isProcedure: PropTypes.bool
};

ProposalCapitalSummary.defaultProps = {
  isCNA: false
};

export default memo(ProposalCapitalSummary);
